import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import type { InputOf } from "../../useMbcAdminMutation";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { assignDefaultGuideline } from "../api";

export function useAssignDefaultGuideline(): UseMutationResult<
  void,
  Error,
  InputOf<typeof assignDefaultGuideline>
> {
  return useMbcAdminMutation(
    assignDefaultGuideline,
    mbcAdminKeys.assignments(),
  );
}
